import React from 'react'

import { usePrevious } from 'helpers/use-previous'

import './badge.scss'

interface IxBadgeProps {
    value: number | undefined,
    iconBadge?: boolean,
}

export const IxBadge = ({value, iconBadge=false}: IxBadgeProps) => {
    const prevBadgeValue = usePrevious(value)

    if (!value) {
        return null
    }

    if (iconBadge) {
        return (
            <span key={value} className={`fa-stack icon-badge ${prevBadgeValue !== undefined ? 'bounce-small' : ''}`}>
                <i className='fa-stack-2x fas fa-circle' />
                <span className='fa-stack-1x badge-text'>{value}</span>
            </span>
        )
    }

    // return (
    //     <span className='item-badge'>
    //         <span key={value} className={`fa-stack ${prevBadgeValue !== undefined ? 'bounce' : ''}`}>
    //             <i className='fa-stack-1x fas fa-circle' />
    //             <span className='fa-stack-1x badge-text'>{value}</span>
    //         </span>
    //     </span>
    // )

    return (
        <span className={ `item-badge ${prevBadgeValue !== undefined ? 'bounce' : ''}` }>
            {value}
        </span>
    )
}
